import React from "react";
import "./PageTitle.css";

const PageTitle = ({ children }) => {
  return <h1 className="page__title">{children}</h1>;
};

export default PageTitle;
